import CreateInvestmentError from './CreateInvestmentError';
class PaymentPlanNotFound extends CreateInvestmentError {
    constructor(options) {
        super('Payment plan id was not found', options);
    }
}
export default PaymentPlanNotFound;
